import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

interface Props extends PickerListProps<server.dto.FreeFieldProfileSmall> {
  environment: server.dto.Environments;
}

const FreefieldProfileList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedFreeFieldProfileInstruction>({
    excludeKeys: [],
    page: 1,
    perPage: 20,
    keyword: "",
    environment: props.environment,
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={i => setInstruction(i)}
    queryKey="listFreefieldProfile"
    api={window.CoreApi.FreeFieldProfile.PaginatedSmall}
    onClick={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={ff => ff.freeFieldProfileId}
    renderListItem={ff => <>
      <div>{ff.title}</div>
    </>}
  />;
};

export default FreefieldProfileList;